module.exports = __webpack_public_path__ + "static/media/04-01.02682e49.mp3";